module.exports = __webpack_public_path__ + "img/condition_specific_health_service_pic.5cf96e8e.png";